(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kicksown-handwritten-letter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.letterReady === 'true') return;
      root.dataset.letterReady = 'true';

      const writing = root.querySelector('[data-letter-writing]');
      const open = root.querySelector('[data-letter-open]');
      const body = root.querySelector('[data-letter-body]');
      const fullText = writing?.dataset.fullText || '';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const write = () => {
        if (!writing) return;
        if (reduceMotion || Shopify.designMode) {
          writing.textContent = fullText;
          return;
        }

        writing.textContent = '';
        writing.classList.add('is-writing');
        let index = 0;
        const step = () => {
          writing.textContent = fullText.slice(0, index);
          index += 1;
          if (index <= fullText.length) {
            window.setTimeout(step, 70 + Math.random() * 90);
          } else {
            writing.classList.remove('is-writing');
          }
        };
        step();
      };

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        write();
        observer.disconnect();
      }, { threshold: .35 });

      if (writing) observer.observe(writing);
      open?.addEventListener('click', () => body?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }));
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-ks-handletter]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
